import { Issue, IssueGroup } from '../../api/issues';
import { RequeuePreview } from '../data/cockpit';
import { Owner } from '../components/ui';

/** Who has to act on one issue: us (also when it needs offering again), the customer, or nobody. */
export const ownerOfIssue = (i: Pick<Issue, 'status'>): Owner => {
    switch (i.status) {
        case 'WaitingOnUs':
        case 'NeedsRequeue':
            return 'us';
        case 'WaitingOnCustomer':
            return 'cu';
        default:
            return 'au';
    }
};

/** Who has to act on a kind of problem: whoever has the most open ones waiting on them. */
export const ownerOfGroup = (g: Pick<IssueGroup, 'waitingOnUs' | 'waitingOnCustomer' | 'needsRequeue'>): Owner => {
    if (g.waitingOnUs + g.needsRequeue > 0 && g.waitingOnUs + g.needsRequeue >= g.waitingOnCustomer) return 'us';
    if (g.waitingOnCustomer > 0) return 'cu';
    return 'au';
};

export const isOpen = (i: Pick<Issue, 'status'>) => i.status !== 'Resolved' && i.status !== 'Closed';

/** The requeue column: a short label and its colour. */
export const verdictLook = (p?: RequeuePreview): { text: string; cls: string } => {
    if (!p) return { text: '…', cls: 'chip' };
    switch (p.verdict) {
        case 'auto':
            return { text: p.nextAt ? `Vanzelf · ${new Date(p.nextAt).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Amsterdam' })}` : 'Vanzelf', cls: 'own au' };
        case 'may':
            return { text: 'Mag · controles ok', cls: 'chip ok' };
        case 'no':
            return { text: `Nee · ${p.reason ?? 'tegengehouden'}`, cls: 'chip bad' };
        case 'na':
            return { text: 'Helpt niet', cls: 'chip' };
        default:
            return { text: 'Nog niet nagekeken', cls: 'chip warn' };
    }
};

/** The document an issue is about, as people call it. */
export const issueLabel = (i: Pick<Issue, 'invoiceId' | 'relationId' | 'objectType'>) => i.invoiceId || i.relationId;

const OBJECT_NAMES: Record<string, string> = {
    Customer: 'klant',
    Invoice: 'factuur',
    InvoiceSalesEntry: 'factuur',
    CreditNote: 'creditnota',
    CreditNoteSalesEntry: 'creditnota',
    PaymentOnline: 'betaling',
    PaymentSalesEntry: 'betaling',
    PaymentOnlineCredit: 'terugbetaling',
    Refund: 'terugbetaling',
};

export const objectName = (objectType?: string | null) => (objectType ? OBJECT_NAMES[objectType] ?? objectType : '');
